const byDivAndDepGraphTypes = {
  div: 'Division',
  dep: 'Department',
};

export default byDivAndDepGraphTypes;
